import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const propelInit = function() {
const sliders = document.querySelectorAll(
	'.block-media-carousel-full .swiper:not(.swiper-initialized)'
);

sliders.forEach((slider) => {
	const parentBlock = slider.closest('.acf-block');
	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 12;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 12;

	const settings = {
		loop: true,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 'auto',
		centeredSlides: true,
		modules: [A11y, Navigation],
		slideClass: 'wp-block-image',
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			768: {
				spaceBetween: desktopGap,
			},
		},
		on: {
			transitionEnd(swiper) {
				if (1 === swiper.activeIndex) {
					swiper.loopFix();
				}
			},
		},
	};

	// Deferred two to avoid forced reflow. Make sure CSS makes the block appear the same before and after swiper initializes, to avoid CLS.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['media-carousel-full'] = window.propel.blocks['media-carousel-full'] || {};
window.propel.blocks['media-carousel-full'].script = propelInit;
